import React, { Fragment, useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { verification } from "../../actions/auth";

//components
// import BreadCrumb from "../../components/breadcrumb/breadcrumb";

// import Alert from "../../components/alert/alert.component";

const Login = (props) => {
  const [values, setValues] = useState(
    {
      loading: false, message: "", class: "" 
    }
  )
  useEffect(() => {
    window.scrollTo(0, 0);
    const id = window.location.toString().split("?id=")[1];

    if (id) {
      checkVerification(id);
    }
  }, [])
  
  const checkVerification = async (id) => {
    const res = await props.verification(id);

    if (res.status === 200) {
      setValues({...values, message: res.data.message, class: "alert-success" });
    }
    if (res.status === 404) {
      setValues({...values, message: res.data.err, class: "alert-danger" });
    }
    if (res.status === 500) {
      setValues({...values, message: "Something Went Wrong", class: "alert-danger" });
    }
  };
  // onSubmit = async (e) => {
  //   e.preventDefault();
  //   setValues({...values, loading: true });

  //   const data = {
  //     email: values.email,
  //     password: values.password,
  //   };
  //   await props.login(data);

  //   const res = await props.auth();

  //   if (localStorage.getItem("checkout") === true) {
  //     props.history.push("/checkout");
  //   }

  //   if (!res) {
  //     setValues({...values, loading: false });
  //   }
  // };

    const { isAuth } = props._auth;
    return (
      <Fragment>
        <div className="create-an-account">
          <div className="regester-top">
            <div className="container">
              <div className="row mx-md-5">
                <header className="col-md-12" id="create-acc-header">
                  {/*<strong>
                    <Link
                      className="navbar-brand"
                      to="/"
                      id="logo"
                      title="sundialhomeproducts.com"
                    >
                      Sundial
                    </Link>
                  </strong>*/}
                  <span className="secure-login">
                    Account Verification <i className="fa fa-lock" />
                  </span>
                </header>
              </div>
            </div>
          </div>
          <div className="create-account">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div id="acc-container text-center">
                    <h4 style={{ marginTop: "15px" }}>
                      {values.message && (
                        <div
                          className={`alert ${values.class}`}
                          role="alert"
                          style={{
                            width: "100%",
                            marginBottom: "2%",
                            marginTop: "2%",
                          }}
                        >
                          {values.message}
                        </div>
                      )}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

verification.propTypes = {
  verification: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  _auth: state.auth,
});

export default connect(mapStateToProps, { verification })(Login);
